export default "__VITE_ASSET__BpXP7hSc__"